<template>
  <div class="w-100">
    <div class="mandate-presence-logs-block">
      <!-- Participant arrived events -->
      <div v-if="showLogs" class="d-block mandate-presence-logs-div text-success text-center mb-3">
        <div class="mandate-presence-logs">
          <div
            v-for="(event, index) in participantArrivedEvents"
            :key="`participant-arrived-${index}`"
            class="position-relative"
          >
            <b-badge
              :id="uniqId()"
              variant="light"
              class="cursor-pointer text-success"
              @click="attachTooltip($event, event)"
            >
              {{ $moment(event.date).format("HH:mm:ss") }}
            </b-badge>
            <appRemoveMinuteEventIcon
              v-if="
                (showIrregularLogsMessage &&
                  participantArrivedEvents.length > participantLeftEvents.length) ||
                participantArrivedEvents.length > 1
              "
              class="ml-2"
              :event="event"
            />
          </div>
        </div>
        <b-badge
          v-if="showOnParticipantArrivedBtn"
          variant="light"
          class="text-success icon-click"
          @click="onParticipantArrived"
        >
          <font-awesome-icon icon="sign-in-alt" />
        </b-badge>
      </div>
      <!-- Participant left events -->
      <div v-if="showLogs" class="d-block mandate-presence-logs-div text-danger text-center">
        <div class="mandate-presence-logs">
          <div
            v-for="(event, index) in participantLeftEvents"
            :key="`participant-left-${index}`"
            class="position-relative"
          >
            <b-badge
              :id="uniqId()"
              variant="light"
              class="cursor-pointer text-danger"
              @click="attachTooltip($event, event)"
            >
              {{ $moment(event.date).format("HH:mm:ss") }}
            </b-badge>
            <appRemoveMinuteEventIcon
              v-if="showIrregularLogsMessage || participantLeftEvents.length > 0"
              class="ml-2"
              :event="event"
              :allow-remove-left-event="true"
              @removeEvent="removeMinuteEventAndMandate"
            />
          </div>
        </div>
        <b-badge
          v-if="showOnParticipantLeftBtn"
          variant="light"
          class="text-danger icon-click"
          @click="openModalAskMoveMandates"
        >
          <font-awesome-icon icon="sign-out-alt" />
        </b-badge>
      </div>
      <!-- irregular presence logs message -->
      <div v-if="showIrregularLogsMessage" class="my-3">
        <appIrregularMinutesLogsIcon :mandate-id="mainMandate.id" />
      </div>
      <div v-if="showContactsPouvoirsVideoMessage">
        <b-badge
          :id="`popover-info-pouvoir-by-video-not-present-yet-${mainMandate.id}`"
          pill
          variant="dark"
        >
          <font-awesome-icon icon="info" size="1x" />
          <b-popover
            :target="`popover-info-pouvoir-by-video-not-present-yet-${mainMandate.id}`"
            triggers="hover"
            placement="top"
          >
            Contacts avec des pouvoirs qui ne se sont pas encore connectés
          </b-popover>
        </b-badge>
      </div>
      <!-- Modal Ask Move Mandates -->
      <b-modal
        v-if="showModalAskMoveMandates"
        :id="`modal-ask-move-mandates-${mainMandate.id}`"
        :visible="true"
        size="xl"
        hide-footer
        centered
        @hide="closeModalAskMoveMandates"
      >
        <modalAskMoveMandates
          :meeting="meeting"
          :options="moveMandatesOptions"
          :mandates="representedMandates"
          @action="MOVE_MANDATES($event)"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import modalAskMoveMandates from "@/components/b-table-components/modals/AskMoveMandates";

import MeetingMW from "@/middlewares/Meeting";
import MeetingORM from "@/store/orm-axios/models/Meeting";

import MandateMW from "@/middlewares/Mandate";
import MandateORM from "@/store/orm-axios/models/Mandate";

import meetingPresenceMixin from "@/mixins/meeting-presence";
import mandatePresenceMixin from "@/mixins/mandate-presence";
import minutesMixin from "@/mixins/minutes";
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";

import appRemoveMinuteEventIcon from "@/components/snippets/RemoveMinuteEventIcon";
import appIrregularMinutesLogsIcon from "@/components/snippets/IrregularMinutesLogsIcon";

import AppTooltip from "@/components/snippets/Tooltip";
import Vue from "vue";
var uuid = require("uuid");

import { meetingMinutesNames } from "@/constants/meeting.js";

export default {
  components: {
    modalAskMoveMandates,
    appRemoveMinuteEventIcon,
    appIrregularMinutesLogsIcon,
  },
  mixins: [
    meetingPresenceMixin,
    mandatePresenceMixin,
    minutesMixin,
    meetingPresenceSelectOptionsMixins,
  ],
  props: {
    mainMandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isVideoCase: {
      type: Boolean,
      default: false,
    },
    isDummyVideoCase: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoadingSave: false,
      showModalAskMoveMandates: false,
    };
  },
  computed: {
    showOnParticipantArrivedBtn() {
      return (
        this.participantArrivedEvents.length == this.participantLeftEvents.length &&
        !(
          this.mainMandate.presence_status == this.mandatePresenceStatuses.video &&
          !this.mainMandate.dummy_video_presence_status
        )
      );
    },
    showOnParticipantLeftBtn() {
      return (
        this.participantArrivedEvents.length == this.participantLeftEvents.length + 1 &&
        !(
          this.mainMandate.presence_status == this.mandatePresenceStatuses.video &&
          !this.mainMandate.dummy_video_presence_status
        )
      );
    },
    showLogs() {
      return (
        this.mainMandate.presence_status !=
        this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet
      );
    },
    showContactsPouvoirsVideoMessage() {
      return (
        this.mainMandate.presence_status ==
        this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet
      );
    },
    showIrregularLogsMessage() {
      return (
        this.mainMandate.presence_status !=
          this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet &&
        ((this.participantArrivedEvents.length !== this.participantLeftEvents.length &&
          this.participantArrivedEvents.length !== this.participantLeftEvents.length + 1) ||
          this.participantArrivedEvents.length == 0)
      );
    },

    representedMandates() {
      var items = this.$_.filter(this.presenceMandates, item => {
        if (this.mainMandate.representant_owner_id)
          return item.representant_owner_id == this.mainMandate.representant_owner_id;
        else if (this.mainMandate.representant_contact_id)
          return item.representant_contact_id == this.mainMandate.representant_contact_id;
      });

      // NOTE: show represented by himself first
      items = this.$_.sortBy(items, item => {
        return item.representant_owner_id !== item.building_owner_id;
      });

      return items;
    },
    moveMandatesOptions() {
      var a = this.getBOsCsShowedUpNotAbsentGroupedOpts(this.mainMandate);
      var b = this.getBOsCsNotShowUpNotIntendToGroupedOpts();

      return [].concat(a, b);
    },
    meeting() {
      return MeetingORM.getters("getById")(this.$route.params.id);
    },
    meetingMinutes() {
      var self = this;
      if (this.meeting) {
        return this.$_.filter(this.meeting.minutes, function (event) {
          if (event.representant_type == "owner")
            return event.representant_id == self.mainMandate.representant_owner_id;
          else if (event.representant_type == "contact")
            return event.representant_id == self.mainMandate.representant_contact_id;
          else return false;
        });
      } else {
        return [];
      }
    },
    participantArrivedEvents() {
      return this.$_.filter(this.meetingMinutes, function (event) {
        return (
          event.event == meetingMinutesNames.participant_arrived ||
          event.event == meetingMinutesNames.contact_arrived
        );
      });
    },
    participantLeftEvents() {
      return this.$_.filter(this.meetingMinutes, function (event) {
        return (
          event.event == meetingMinutesNames.participant_left ||
          event.event == meetingMinutesNames.contact_left
        );
      });
    },
  },
  methods: {
    openModalAskMoveMandates() {
      this.showModalAskMoveMandates = true;
    },
    closeModalAskMoveMandates() {
      this.showModalAskMoveMandates = false;
    },
    // !!!: Move Mandates when Leaving (function)
    // this.mainMandate is the mandate of left building owner
    // selectedOwnersOrContacts obj key is the mandate id and its value is future representant if it exists
    async MOVE_MANDATES(selectedOwnersOrContacts) {
      this.$store.state.showLoaderOverlay = true;

      // use this var instead of directly accesing through `this` in all function to prevent issues caused by DOM update
      var mainMandate = this.mainMandate;
      this.$bvModal.hide(`modal-ask-move-mandates-${mainMandate.id}`);

      try {
        // get type and id of participant
        var participantRepresentantType,
          participantRepresentantId = null;
        if (mainMandate.representant_owner_id) {
          participantRepresentantType = "owner";
          participantRepresentantId = mainMandate.representant_owner_id;
        } else if (mainMandate.representant_contact_id) {
          participantRepresentantType = "contact";
          participantRepresentantId = mainMandate.representant_contact_id;
        }

        // NOTE: for every selectedOwnerOrContact value iterate and update mandates accordingly
        var parentMandateLeft = null;
        for (let [mandateId, selectedOwnerOrContact] of Object.entries(selectedOwnersOrContacts)) {
          // if selectedOwnerOrContact == null, presence status == not_present, else -> pouvoir
          if (selectedOwnerOrContact) {
            // value here is the future representant
            // NOTE: sets "mandate-moved" event | it also sets the presence status = pouvoir
            await this.setFutureRepresentantOfMandate(
              selectedOwnerOrContact,
              mandateId,
              mainMandate
            );
          } else {
            // the mandate has no future representant
            // if value is not set -> "mandate-left" event is inserted and presence_status = not_present
            var mandate = MandateORM.find(mandateId);
            if (
              (mandate.representant_owner_id &&
                mandate.representant_owner_id != mandate.building_owner_id) ||
              mandate.representant_contact_id
            ) {
              await this.setNotPresentAndAddMandateLeftEvent(mandateId);
            } else if (
              mandate.representant_owner_id &&
              mandate.representant_owner_id == mandate.building_owner_id
            ) {
              parentMandateLeft = mandate;
            }
          }
        }

        // NOTE: update parent after updating children, so that the computations for tantiemes and presence info will not be affected
        if (parentMandateLeft) {
          await this.setMandatePresenceStatus(parentMandateLeft, "not_present");
        }

        // !!!: NOTE: ???: participant-left/contact-left events will appear after mandate events if this functions get called at the end.
        //            tantiemes values calculated for meeting minutes will be different from if this would be called before mandate events. (regarding total present mandates tantiemes, for example)
        //            not sure what is wanted...
        //            similar events regarding the case when it's by video is different: participant-left/contact-left events appear before the mandates events and the calculations are different (again, regarding total present mandates tantiemes, for example)
        if (participantRepresentantType == "owner") {
          await this.setParticipantLeftEvent(mainMandate.id, true);
        } else if (participantRepresentantType == "contact") {
          await this.setContactLeftEvent(participantRepresentantId, true);
        }

        this.$store.state.showLoaderOverlay = false;
      } catch (err) {
        this.$store.state.showLoaderOverlay = false;
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    async onParticipantArrived() {
      var self = this;
      // use this var instead of directly accesing through `this(self)` in all function to prevent issues caused by DOM update
      var mainMandate = self.mainMandate;

      self
        .$swal(self.alertQuestion())
        .then(async res => {
          if (res.value) {
            // choose presence type for participant arrived
            var chosenPresenceType = await this.promptPresenceType(this.meeting);

            if (chosenPresenceType) {
              var dummyVideoPresenceStatusChosen = chosenPresenceType == "video" ? true : false;
              var mainPresenceStatusChosen = chosenPresenceType == "video" ? "video" : "physical";
              var representedPresenceStatusChosen =
                chosenPresenceType == "video" ? "pouvoir_by_video" : "pouvoir";

              self.$store.state.showLoaderOverlay = true;
              // get the representant owner id that logs in
              var mandate = MandateORM.query()
                .where("meeting_id", this.$route.params.id)
                .where(m => {
                  return m.building_owner_id == mainMandate.building_owner_id;
                })
                .first();

              var mandateLastPresenceStatus = mandate.presence_status;
              if (mandate.representant_contact_id) {
                await self.setMandatePresenceStatus(
                  mandate,
                  representedPresenceStatusChosen,
                  true,
                  dummyVideoPresenceStatusChosen
                );
                self.setContactArrivedEvent(mandate.representant_contact_id, false);
                self.setMandateAddedEvent(mandate.id, false);
              } else {
                await self.setMandatePresenceStatus(
                  mandate,
                  mainPresenceStatusChosen,
                  true,
                  dummyVideoPresenceStatusChosen
                );
                self.setParticipantArrivedEvent(mandate.id, false);
              }

              // ???: ??
              if (mandateLastPresenceStatus == this.mandatePresenceStatuses.correspondence) {
                await self.deleteVotesByCorrespondenceForResolutionsThatWereNotVoted(mandate);
              }

              await self.setEventsForRepresentedMandates(
                mainMandate.representant_owner_id || mainMandate.representant_contact_id,
                mandate.id,
                representedPresenceStatusChosen,
                dummyVideoPresenceStatusChosen,
                mainMandate
              );

              self.isLoadingSave = true;
              var meeting = MeetingORM.find(self.meeting.id);
              try {
                await MeetingMW.PUT(meeting, false);
              } catch (err) {
                console.error(err);
                self.$swal(
                  self.alertError(
                    null,
                    "Erreur lors de la sauvegarde de l'heure d'arrivée. Veuillez réessayer.",
                    3500
                  )
                );
              } finally {
                self.isLoadingSave = false;
                self.$store.state.showLoaderOverlay = false;
              }
            }
          }
        })
        .catch(err => {
          console.error(err);
          self.$store.state.showLoaderOverlay = false;
          self.$swal(self.alertError());
        });
    },
    async setEventsForRepresentedMandates(
      representant_id,
      ignored_mandate_id,
      representedPresenceStatusChosen,
      dummyVideoPresenceStatusChosen,
      mainMandate
    ) {
      if (representant_id) {
        let representedMandates = MandateORM.query()
          .where(m => {
            return (
              m.meeting_id == mainMandate.meeting_id &&
              (m.representant_owner_id == representant_id ||
                m.representant_contact_id == representant_id) &&
              m.id != ignored_mandate_id // exlude the already updated mandate
            );
          })
          .get();

        for (let representedMandate of representedMandates) {
          await this.setMandatePresenceStatus(
            representedMandate,
            representedPresenceStatusChosen,
            true,
            dummyVideoPresenceStatusChosen
          );
          this.setMandateAddedEvent(representedMandate.id, false);
        }
      } else {
        console.error("representant_id was not set");
      }
    },
    // NOTE:
    // 1. selected is participant owner or contact (...)
    // 2. selected is non participant owner : ADD instead of CREATE mandate for it (showed_up)
    //                                        add participant-arrived event
    //                                        update current mandate & add mandate-moved event
    // 3. selected is non participant contact : add contact-arrived event + update current mandate & add mandate-moved event
    // 4. case select add contact : show create contact popup, create contact then set option selected to it
    //                              case (3) then...
    async setFutureRepresentantOfMandate(selectedOwnerOrContact, mandateId, mainMandate) {
      var self = this;

      if (!selectedOwnerOrContact.isParticipant) {
        if (selectedOwnerOrContact.type == "owner") {
          var selectedOwnerMandate = MandateORM.query()
            .where(item => {
              return (
                item.meeting_id == mainMandate.meeting_id &&
                item.building_owner_id == selectedOwnerOrContact.id &&
                item.presence_status != this.mandatePresenceStatuses.physical
              );
            })
            .first();

          if (selectedOwnerMandate) {
            selectedOwnerMandate = JSON.parse(JSON.stringify(selectedOwnerMandate));

            selectedOwnerMandate.presence_status =
              selectedOwnerOrContact.presenceType == "video"
                ? this.mandatePresenceStatuses.video
                : this.mandatePresenceStatuses.physical;
            selectedOwnerMandate.dummy_video_presence_status = selectedOwnerOrContact.hasDummyVideoPresenceStatus
              ? 1
              : 0;

            selectedOwnerMandate.showed_up = 1;
            selectedOwnerMandate.representant_contact_id = null;
            selectedOwnerMandate.representant_owner_id = selectedOwnerOrContact.id;

            await MandateMW.PUT(selectedOwnerMandate)
              .then(() => {
                this.setParticipantArrivedEvent(selectedOwnerMandate.id, false);
              })
              .catch(err => {
                console.error(err);
              });
          }
        } else if (selectedOwnerOrContact.type == "contact") {
          var selectedContactMandate = MandateORM.query()
            .where("meeting_id", mainMandate.meeting_id)
            .where("representant_contact_id", selectedOwnerOrContact.id)
            .first();

          if (!selectedContactMandate) {
            this.setContactArrivedEvent(selectedOwnerOrContact.id, false);
          }
        }
      }

      var mandate = MandateORM.find(mandateId);
      var mandateCopy = JSON.parse(JSON.stringify(mandate));

      // sets mandate representant contact or owner: depending on type
      mandateCopy.representant_contact_id =
        selectedOwnerOrContact.type == "contact" ? selectedOwnerOrContact.id : null;
      mandateCopy.representant_owner_id =
        selectedOwnerOrContact.type == "owner" ? selectedOwnerOrContact.id : null;

      mandateCopy.presence_status =
        selectedOwnerOrContact.presenceType == "video"
          ? this.mandatePresenceStatuses.pouvoir_by_video
          : this.mandatePresenceStatuses.pouvoir;

      mandateCopy.dummy_video_presence_status = selectedOwnerOrContact.hasDummyVideoPresenceStatus
        ? 1
        : 0;

      // SAVES THE LAST REPRESENTANT TYPE AND ID
      var moveFromRepresentantType = mandate.representant_owner_id ? "owner" : "contact";
      var moveFromRepresentantId = mandate.representant_owner_id
        ? mandate.representant_owner_id
        : mandate.representant_contact_id;

      // SAVES NEW REPRESENTANT TYPE AND ID
      var moveToRepresentantType = mandateCopy.representant_owner_id ? "owner" : "contact";
      var moveToRepresentantId = mandateCopy.representant_owner_id
        ? mandateCopy.representant_owner_id
        : mandateCopy.representant_contact_id;

      await MandateMW.PUT(mandateCopy)
        .then(async () => {
          // NOTE: add mandate-moved event in meeting minutes
          self.setMandateMovedEvent(mandateCopy.id, {
            moveFromRepresentantType,
            moveFromRepresentantId,
            moveToRepresentantType,
            moveToRepresentantId,
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    async setNotPresentAndAddMandateLeftEvent(mandateId) {
      var mandate = MandateORM.find(mandateId);

      await this.setMandatePresenceStatus(mandate, "not_present");
      // create event mandate-left
      this.setMandateLeftEvent(mandate.id, false);
    },
    attachTooltip(e, data) {
      const TooltipClass = Vue.extend(AppTooltip);
      const tooltipInstance = new TooltipClass({
        propsData: {
          event: data,
          id: e.target.id,
        },
      });
      tooltipInstance.$mount(e.target.parent);
      tooltipInstance.$on("change", changeEvent => {
        this.changeMinuteEventDate(changeEvent.newDate, changeEvent.minuteEvent).then(() => {
          tooltipInstance.$destroy();
        });
      });
      tooltipInstance.$on("destroy-tooltip", () => {
        tooltipInstance.$destroy();
      });
    },
    uniqId() {
      return uuid.v4();
    },
    async removeMinuteEventAndMandate(data) {
      await this.removeMinuteEvent(data.event, data.saveInDb);
      var mandate = MandateORM.find(data.event.mandate_id);
      mandate.presence_status = mandate.last_presence_status;
      mandate.last_presence_status = null;
      mandate.dummy_video_presence_status = 1;
      MandateORM.update({
        where: mandate.id,
        data: mandate,
      });
      MandateMW.PUT(mandate, false).catch(err => {
        console.error(err);
      });
      this.removeMinuteEventAndMandateRepresentants(
        mandate.representant_owner_id || mandate.representant_contact_id,
        mandate.id
      );
    },
    removeMinuteEventAndMandateRepresentants(representant_id, ignored_mandate_id) {
      if (!representant_id) {
        return;
      }
      var ignored_mandate = MandateORM.find(ignored_mandate_id);
      let representedMandates = MandateORM.query()
        .where(m => {
          return (
            m.meeting_id == ignored_mandate.meeting_id &&
            (m.representant_owner_id == representant_id ||
              m.representant_contact_id == representant_id) &&
            m.id != ignored_mandate_id // exlude the already updated mandate
          );
        })
        .get();
      for (let representedMandate of representedMandates) {
        representedMandate.presence_status = representedMandate.last_presence_status;
        representedMandate.last_presence_status = null;
        representedMandate.dummy_video_presence_status = 1;
        MandateORM.update({
          where: representedMandate.id,
          data: representedMandate,
        });
        MandateMW.PUT(representedMandate, false).catch(err => {
          console.error(err);
        });
      }
    },
  },
};
</script>
